import { useEffect } from "react";
import useIsOpenModalShowDetail from "./useIsOpenModalShowDetail";

const useFireRevalidateOnCloseModalShowDetail = (
  revalidate: VoidFunction,
): void => {
  const open = useIsOpenModalShowDetail();
  useEffect(() => {
    if (!open) {
      revalidate();
    }
  }, [open]);
};

export default useFireRevalidateOnCloseModalShowDetail;
